import React from "react";
import { Link, Tooltip } from "@mui/material";
import { useNavigate } from "react-router";
import ViewIcon from "../../../../assets/images/view.png";
import { internalReferralTypeLabels } from "../Constants";
import { ViewDateTime } from "../../../../utils/DateSupport";

const capitalizeName = (name) =>
  name
    ? name.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
    : "-";

const InternalReferralRow = ({ data, practionerData, onViewDetails }) => {
  const navigate = useNavigate();
  const sourceEncounterId = data?.encounter?.reference?.split("/")?.[1];
  const targetEncounterId = data?.targetEncounter?.reference?.split("/")?.[1];

  const openEncounter = (encounterId) =>
    navigate("/app/encounter-details", {
      state: { encounterId, practionerData, from: "fromServiceReq" },
    });

  const renderEncounterLink = (encounterId, tooltip) =>
    encounterId ? (
      <Tooltip title={tooltip}>
        <span
          style={{ cursor: "pointer", color: "#0064a6", textDecoration: "underline" }}
          onClick={() => openEncounter(encounterId)}
        >
          {encounterId}
        </span>
      </Tooltip>
    ) : (
      "-"
    );

  return (
    <tr key={data?.id}>
      <td>{ViewDateTime(data?.authoredOn || data?.updatedAt)}</td>
      <td>{capitalizeName(data?.practitionerName)}</td>
      <td>{renderEncounterLink(sourceEncounterId, "View Source Encounter Details")}</td>
      <td>
        {renderEncounterLink(targetEncounterId, "View Referral Encounter Details")}
      </td>
      <td>{data?.targetServiceLine?.display || "-"}</td>
      <td>{internalReferralTypeLabels[data?.referralType] || "-"}</td>
      <td>
        <div className="action-wrap">
          <Tooltip title={"View Referral Details"}>
            <Link
              to=""
              variant="primary"
              className="view-btn"
              onClick={() => onViewDetails(data)}
            >
              <img src={ViewIcon} alt="View Referral Details" />
            </Link>
          </Tooltip>
        </div>
      </td>
    </tr>
  );
};

export default InternalReferralRow;
